import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { appInit } from '~/Actions/ActionApp';
import { useWillMount } from '~/hooks';
import { AppDispatch } from '~/appDispatch';

const Init = () => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  useWillMount(() => {
    dispatch(appInit(location));
  });

  return <></>;
};

export default Init;
